module.exports = __webpack_public_path__ + "./config/cox-dev.json";